import { IBaseAction, IPromiseParam } from './../base';
import * as types from './actionTypes.config';

export const getStudioConfig = ({ resolve, reject }
    : IPromiseParam & IBaseAction)
    : IPromiseParam & IBaseAction =>
({
    type: types.GET_STUDIO_CONFIG_REQ,
    resolve,
    reject
});

export const getVoicesConfig = ({ resolve, reject }
    : IPromiseParam & IBaseAction)
    : IPromiseParam & IBaseAction => ({
        type: types.GET_VOICES_CONFIG_REQ,
        resolve, reject
    });

export const getWakeWordAcusticModelsConfig = ({ resolve, reject }
    : IPromiseParam & IBaseAction)
    : IPromiseParam & IBaseAction => ({
        type: types.GET_WAKEWORD_ACUSTIC_MODELS_CONFIG_REQ,
        resolve, reject
    });

export const getSLUVersionsConfig = ({ resolve, reject }
    : IPromiseParam & IBaseAction)
    : IPromiseParam & IBaseAction => ({
        type: types.GET_SLU_VERSION_CONFIG_REQ,
        resolve, reject
    });


export const getFeaturesConfig = ()
    : IBaseAction => ({
        type: types.GET_FEATURES_CONFIG_REQ,
    });
